import { render, staticRenderFns } from "./TimetableTemplate.vue?vue&type=template&id=6bcd50d6"
import script from "./TimetableTemplate.vue?vue&type=script&lang=js"
export * from "./TimetableTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports